import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import People from "../../components/workforce/People";
import Companies from "../../components/workforce/Companies";
import Schedule from "../../components/workforce/Schedule";
import Timesheets from "../../components/workforce/Timesheets";
import Procurement from "../../components/workforce/Procurement";
import Equipment from "../../components/workforce/Equipment";
import Reports from "../../components/workforce/Reports";

const EXTERNAL = ["SUBCONTRACTOR", "VENDOR_SUPPLIER", "CONTRACTOR_1099"];
const ADMIN = ["OWNER_SUPER_ADMIN", "ADMINISTRATOR"];
const TABS = [["people", "People"], ["companies", "Subcontractors"], ["schedule", "Schedule"], ["timesheets", "Timesheets"],
  ["procurement", "Procurement"], ["equipment", "Equipment & inventory"], ["reports", "Reports"]];

// B11: workforce, subcontractors, procurement & equipment. The server enforces every permission; tabs only hide dead ends.
export default function WorkforceHome() {
  const { user } = useAuth();
  const role = user?.role_key;
  const external = EXTERNAL.includes(role);
  const tabs = external ? TABS.filter(([k]) => ["people", "companies", "schedule"].includes(k)) : TABS;
  const [sp, setSp] = useSearchParams();
  const tab = tabs.some(([k]) => k === sp.get("tab")) ? sp.get("tab") : tabs[0][0];
  const [projects, setProjects] = useState([]);
  const [workers, setWorkers] = useState([]);
  useEffect(() => {
    api.get("/workforce/workers").then((r) => setWorkers(r.data)).catch(() => setWorkers([]));
    if (!external) api.get("/phase4/projects").then((r) => setProjects(r.data.items || [])).catch(() => setProjects([]));
  }, [external]);
  const canAdmin = ADMIN.includes(role);
  const body = { people: <People canAdmin={canAdmin} />, companies: <Companies canAdmin={canAdmin} />, schedule: <Schedule projects={projects} workers={workers} />,
    timesheets: <Timesheets projects={projects} workers={workers} />, procurement: <Procurement projects={projects} />,
    equipment: <Equipment projects={projects} />, reports: <Reports /> }[tab];
  return (
    <AppShell title="Workforce" subtitle="People, subcontractors, crews, time, purchasing and equipment">
      <div className="mx-auto w-full max-w-[1100px] px-4 space-y-4" data-testid="wf-home">
        <div role="tablist" aria-label="Workforce sections" className="flex flex-wrap gap-2">
          {tabs.map(([k, l]) => (
            <button key={k} type="button" role="tab" aria-selected={tab === k} onClick={() => setSp({ tab: k })} data-testid={`wf-tab-${k}`}
              className={`min-h-[44px] px-3 rounded border text-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${tab === k ? "bg-erf-navy text-white border-erf-navy" : "bg-white border-erf-borderCream hover:bg-erf-cream"}`}>{l}</button>))}
        </div>
        <div role="tabpanel">{body}</div>
      </div>
    </AppShell>
  );
}
